import { useSelector } from 'react-redux';
import { PRIMARY_ORANGE } from '../../../../constants/theme';
import './TeamMetrics.scss';

const TeamMetrics = ({
  highestCompetencyScore,
  lowestCompetencyScore,
}) => {
  const employeesList = useSelector((state) => state?.employees);
  const tasks = useSelector((state) => state?.tasks);

  return (
    <div className="team-metrics-grid">
      <div className="team-metrics-card">
        <div className="team-metrics-card-content">
          <div>
            <p className="team-metrics-label">Maior pontuação de competência</p>
            <h3 className="team-metrics-value">
              {highestCompetencyScore.score}/
              {highestCompetencyScore.loadingExpected ? (
                <span className="skeleton skeleton-number" style={{ width: 24, height: 32, display: 'inline-block', verticalAlign: 'middle' }}></span>
              ) : (
                highestCompetencyScore.expected
              )}
            </h3>
            <p className="team-metrics-name-green">{highestCompetencyScore.name}</p>
          </div>
          <div className="team-metrics-icon-green">
            <svg width="24" height="24" fill="none" stroke="#4ade80" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
              <polyline points="16 7 22 7 22 13" />
            </svg>
          </div>
        </div>
      </div>

      <div className="team-metrics-card">
        <div className="team-metrics-card-content">
          <div>
            <p className="team-metrics-label">Menor pontuação de competência</p>
            <h3 className="team-metrics-value">
              {lowestCompetencyScore.score}/
              {lowestCompetencyScore.loadingExpected ? (
                <span className="skeleton skeleton-number" style={{ width: 24, height: 32, display: 'inline-block', verticalAlign: 'middle' }}></span>
              ) : (
                lowestCompetencyScore.expected
              )}
            </h3>
            <p className="team-metrics-name-red">{lowestCompetencyScore.name}</p>
          </div>
          <div className="team-metrics-icon-red">
            <svg width="24" height="24" fill="none" stroke="#f87171" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
              <polyline points="16 17 22 17 22 11" />
            </svg>
          </div>
        </div>
      </div>

      <div className="team-metrics-card">
        <div className="team-metrics-card-content">
          <div>
            <p className="team-metrics-label">Conteúdos</p>
            <h3 className="team-metrics-value"> {tasks?.isFetching ? (
              <span className="skeleton skeleton-number" style={{ width: 40, height: 32, display: 'inline-block' }}></span>
            ) : (
              tasks?.data?.totalItems
            )}</h3>
            <p className="team-metrics-name-blue">em estudo atualmente</p>
          </div>
          <div className="team-metrics-icon-blue">
            <svg width="24" height="24" fill="none" stroke="#60a5fa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M2 19.5A2.5 2.5 0 0 1 4.5 17H20" />
              <path d="M2 6.5A2.5 2.5 0 0 1 4.5 4H20v16" />
              <path d="M6 4v16" />
            </svg>
          </div>
        </div>
      </div>

      <div className="team-metrics-card">
        <div className="team-metrics-card-content">
          <div>
            <p className="team-metrics-label">Colaboradores</p>
            <h3 className="team-metrics-value">
              {employeesList?.isFetching ? (
                <span className="skeleton skeleton-number" style={{ width: 40, height: 32, display: 'inline-block' }}></span>
              ) : (
                employeesList?.data?.totalItems
              )}
            </h3>
            <p className="team-metrics-name-orange">cadastrados na plataforma</p>
          </div>
          <div className="team-metrics-icon-orange">
            <svg width="24" height="24" fill="none" stroke={PRIMARY_ORANGE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMetrics;
